import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import TodayFeed from "@/pages/home/components/TodayFeed";
import DailyPicks from "@/pages/home/components/DailyPicks";
import HotRank from "@/pages/home/components/HotRank";
import LatestGrid from "@/pages/home/components/LatestGrid";
import TopicWall from "@/pages/home/components/TopicWall";
import Collections from "@/pages/home/components/Collections";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <TodayFeed />
        <DailyPicks />
        <HotRank />
        <LatestGrid />
        <TopicWall />
        <Collections />
      </main>
      <Footer />
    </div>
  );
}